// extracted by mini-css-extract-plugin
export default {"wordpuzzlebutton":"wordpuzzle_wordpuzzlebutton__je-ZA","wrong":"wordpuzzle_wrong__BahqJ","shake":"wordpuzzle_shake__1roF4"};